import React, { useEffect, useState } from "react";
import { zAttrLabelMeta } from "src/common/attributes/makeAttrLabel/types/ZAttrLabelMeta";
import { getViewInfo } from "src/common/attrView";
import { seedSeparators } from "src/common/attrView/viewFormItems/Separator";
import { onError } from "src/common/onError";
import { AttrTypeName } from "src/types/AttrType";
import { classNames } from "src/common/classNames";
import { MakeLabelParams } from "../../../types/MakeLabelParams";
import { getAttrLabelTreeData } from "../../../utils/getAttrLabelTreeData";
import { getEntityLabel } from "../getEntityLabel";
import styles from "./ChildEntitiesLabel.module.less";

interface PropsChildEntitiesLabel {
  params: MakeLabelParams;
}

export const ChildEntitiesLabel: React.FC<PropsChildEntitiesLabel> = ({
  params,
}) => {
  const [label, setLabel] = useState<React.ReactNode>(null);
  const { attribute, attributeList, typesMap } = params;
  const viewInfo = getViewInfo(attribute.viewType);

  useEffect(() => {
    try {
      if (viewInfo?.component?.view !== "ChildEntitiesCellInfo") return;
      const { labelAtts } = viewInfo.component;

      const attrTreeData = getAttrLabelTreeData(
        params.attribute,
        params.labelTreeData,
      );
      if (!attrTreeData) return;
      const meta = zAttrLabelMeta.parse(attrTreeData.attrLabelMeta);
      if (meta.type !== AttrTypeName.childEntities) {
        throw Error("system error");
      }
      const eIds = Object.keys(meta.links);
      const eLabels = eIds.map((id) => [
        id,
        getEntityLabel(
          id,
          attrTreeData,
          attributeList,
          typesMap,
          labelAtts,
          (content) => <span className={styles.separator}>{content}</span>,
        ),
      ]);
      const multiple = eLabels.length > 1;
      const separator = viewInfo.appearance?.view?.separator;
      const finalLabels = (
        <div
          className={classNames([
            [labelAtts.length > 1, styles.box],
            [multiple, styles.multiple],
          ])}
        >
          {seedSeparators(
            eLabels.map(([keyNum, content]) => ({
              key: String(keyNum),
              content,
            })),
            separator,
            (content) => (
              <span
                className={classNames([
                  styles.separator,
                  [separator === "newLine", styles.newLine],
                ])}
              >
                {content}
              </span>
            ),
          )}
        </div>
      );
      setLabel(finalLabels);
    } catch (error) {
      onError(error);
    }
  }, []);

  if (
    viewInfo?.appearance?.view?.separator === "comma" ||
    viewInfo?.appearance?.view?.separator === "slash"
  )
    return <div className={styles.inline}>{label}</div>;
  return label;
};
